import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom';

import About from './views/about';
import Contact from './views/contact';
import Videos from './views/videos';
import Home from './views/home';
import Works from './views/works';

const Routes = () => (
  <Router>
    <Switch>
      <Route exact path="/" component={Home} />
      <Route path="/about" component={About}/>
      <Route path="/contact" component={Contact}/>
      <Route path="/videos" component={Videos}/>
      <Route path="/works/:id" component={Works}/>
    </Switch>
  </Router>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js